"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LoggerService {
    constructor(logger) {
        this.logger = logger;
        this.name = 'console';
    }
    /**
     * @param report - report of the logger
     */
    error(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error(report);
    }
    info(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info(report);
    }
    warn(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn(report);
    }
    debug(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug(report);
    }
    trace(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.trace(report);
    }
    entry(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.entry(report);
    }
    exit(report) {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.exit(report);
    }
}
exports.LoggerService = LoggerService;
//# sourceMappingURL=logger-service.js.map